var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_vm._t("default"),_c('loading-overlay',{attrs:{"loading":_vm.loading}}),_c('SnackBar'),_c('MessageBox')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }